
















import {
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { VueConstructor } from 'vue';
import { FullUser } from '@front-app/services/UserApi/UserModel';
import { EditableSection } from '../editableProfileSections';
import CurrentOccupation from './CurrentOccupation.vue';
import EditOrganization from './EditOrganization.vue';
import SummaryAll from './SummaryAll.vue';
import SummaryContacts from './SummaryContacts.vue';
import PersonalInformation from './PersonalInformation.vue';
import EditRoles from './EditRoles.vue';
import EditSpecialties from './EditSpecialties.vue';
import EditInterests from './EditInterests.vue';
import EditAssociations from './Associations.vue';
import EditProfile from './EditProfile.vue';
import MyLocationWith from './MyLocationWith.vue';
import ProfessionalExperience from './ProfessionalExperience.vue';

const COMPONENT_BY_SECTION: Record<EditableSection, VueConstructor | undefined> = {
	[EditableSection.NONE]: undefined,
	[EditableSection.SUMMARY_ALL]: SummaryAll,
	[EditableSection.SUMMARY_CONTACTS]: SummaryContacts,
	[EditableSection.CURRENT_OCCUPATION]: CurrentOccupation,
	[EditableSection.ORGANIZATION]: EditOrganization,
	[EditableSection.PERSONAL_INFORMATION]: PersonalInformation,
	[EditableSection.ROLES]: EditRoles,
	[EditableSection.SPECIALTIES]: EditSpecialties,
	[EditableSection.INTERESTS]: EditInterests,
	[EditableSection.ASSOCIATIONS]: EditAssociations,
	[EditableSection.MY_LOCATION_WITH]: MyLocationWith,
	[EditableSection.PROFESSIONAL_EXPERIENCE]: ProfessionalExperience,
	[EditableSection.PROFILE]: EditProfile,
};

export default defineComponent({
	props: {
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
		selectedSection: {
			type: Number as PropType<EditableSection | null>,
			required: false,
			default: null,
		},
		isLoading: Boolean,
		isError: Boolean,
		isSuccess: Boolean,
	},
	setup() {
		return {
			EditableSection,
			COMPONENT_BY_SECTION,
		};
	},
});
